import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { GolfTechType } from "src/app/shared/models/golftech-type.enum";
import { injectStripe, StripeCardComponent } from "ngx-stripe";
import { IdentityUserService } from "src/app/shared/services/identity/identity-user.service";
import { GtStripeService } from "src/app/shared/services/gt-stripe.service";
import { StripeCardElementOptions, StripeElementsOptions } from "@stripe/stripe-js";
import { Component, OnInit, ViewChild } from "@angular/core";
import { inject } from "@angular/core";

@Component({ template: '' }) 
export class BaseSignUpComponent implements OnInit{
    public isLoading = false;
    public accountForm: FormGroup;
    public billingForm: FormGroup;
    public golfTechTypeEnum = GolfTechType;
    public golfTechTypeEnumKeys = Object.keys(GolfTechType).filter(key => ['Organizer', 'Simulator'].includes(key));
    public plans: any[] = [];
    public filteredPlans = [];
    public showPassword = false;
    public isCardValid = false;
    public setupIntent: any;
    public states = [
        { name: 'Alabama', abbreviation: 'AL' },
        { name: 'Alaska', abbreviation: 'AK' },
        { name: 'Arizona', abbreviation: 'AZ' },
        { name: 'Arkansas', abbreviation: 'AR' },
        { name: 'California', abbreviation: 'CA' },
        { name: 'Colorado', abbreviation: 'CO' },
        { name: 'Connecticut', abbreviation: 'CT' },
        { name: 'Delaware', abbreviation: 'DE' },
        { name: 'Florida', abbreviation: 'FL' },
        { name: 'Georgia', abbreviation: 'GA' },
        { name: 'Hawaii', abbreviation: 'HI' },
        { name: 'Idaho', abbreviation: 'ID' },
        { name: 'Illinois', abbreviation: 'IL' },
        { name: 'Indiana', abbreviation: 'IN' },
        { name: 'Iowa', abbreviation: 'IA' },
        { name: 'Kansas', abbreviation: 'KS' },
        { name: 'Kentucky', abbreviation: 'KY' },
        { name: 'Louisiana', abbreviation: 'LA' },
        { name: 'Maine', abbreviation: 'ME' },
        { name: 'Maryland', abbreviation: 'MD' },
        { name: 'Massachusetts', abbreviation: 'MA' },
        { name: 'Michigan', abbreviation: 'MI' },
        { name: 'Minnesota', abbreviation: 'MN' },
        { name: 'Mississippi', abbreviation: 'MS' },
        { name: 'Missouri', abbreviation: 'MO' },
        { name: 'Montana', abbreviation: 'MT' },
        { name: 'Nebraska', abbreviation: 'NE' },
        { name: 'Nevada', abbreviation: 'NV' },
        { name: 'New Hampshire', abbreviation: 'NH' },
        { name: 'New Jersey', abbreviation: 'NJ' },
        { name: 'New Mexico', abbreviation: 'NM' },
        { name: 'New York', abbreviation: 'NY' },
        { name: 'North Carolina', abbreviation: 'NC' },
        { name: 'North Dakota', abbreviation: 'ND' },
        { name: 'Ohio', abbreviation: 'OH' },
        { name: 'Oklahoma', abbreviation: 'OK' },
        { name: 'Oregon', abbreviation: 'OR' },
        { name: 'Pennsylvania', abbreviation: 'PA' },
        { name: 'Rhode Island', abbreviation: 'RI' },
        { name: 'South Carolina', abbreviation: 'SC' },
        { name: 'South Dakota', abbreviation: 'SD' },
        { name: 'Tennessee', abbreviation: 'TN' },
        { name: 'Texas', abbreviation: 'TX' },
        { name: 'Utah', abbreviation: 'UT' },
        { name: 'Vermont', abbreviation: 'VT' },
        { name: 'Virginia', abbreviation: 'VA' },
        { name: 'Washington', abbreviation: 'WA' },
        { name: 'West Virginia', abbreviation: 'WV' },
        { name: 'Wisconsin', abbreviation: 'WI' },
        { name: 'Wyoming', abbreviation: 'WY' }
    ];

    @ViewChild(StripeCardComponent) cardElement!: StripeCardComponent;
    public cardOptions: StripeCardElementOptions = {
        style: {
          base: {
            fontFamily: 'Poppins, sans-serif',
            fontSize: '18px',
          },
        },
      };
    
      public elementsOptions: StripeElementsOptions = {
        appearance: {
          theme: 'stripe'
        },
        locale: 'en',
      };

    stripe = injectStripe();
    public identityUserService = inject(IdentityUserService);
    public stripeService = inject(GtStripeService);
    
    constructor(public fb: FormBuilder) { 
        this.accountForm = this.fb.group({
            given_name: ['', Validators.required],
            family_name: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.minLength(6)]]
        }); 
    }

    ngOnInit(): void {
    
    }

    onCardChange(event: any): void {
      this.isCardValid = event.complete && !event.error;
  }
}